import {config} from '../../config';

export default function WisePopsNotifications() {
  if (!config.wisePopsNotificationsSiteId) {
    return null;
  }

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `(function(w,i,s,p){a=document.createElement("script");
        a.src=w+"/embed?website_id="+i;a.onload=function(){
        if(!window.wisp)return;window.wisp.start(w,i,s,p);
        };document.head.appendChild(a);})("https://app.getwisp.co",
        "${config.wisePopsNotificationsSiteId}");`,
      }}
    />
  );
}
